import { DatePipe } from '@angular/common';
import { Inject, InjectionToken, Optional, Pipe, PipeTransform } from '@angular/core';

export type DateFormat =
  | 'short'
  | 'medium'
  | 'long'
  | 'shortDate'
  | 'mediumDate'
  | 'longDate'
  | 'timeFirst'
  | 'timeFirstNoAmPm'
  | 'input'
  | 'dateTimestamp';

export interface LocaleServiceInterface {
  formatDate(value: string | number | Date, format: string, timezone?: string): string;
}

export const LOCALE_SERVICE = new InjectionToken<LocaleServiceInterface>('LocaleService');

@Pipe({
  name: 'fsFormatDate',
  pure: true,
})
export class FsFormatDatePipe implements PipeTransform {
  constructor(@Optional() @Inject(LOCALE_SERVICE) private _localeService: LocaleServiceInterface | null = null) {}

  public transform(
    value: string | number | Date | null | undefined,
    format: DateFormat | string = 'medium',
    timezone?: string
  ): string {
    if (value == null || value === '') {
      return '';
    }

    if (this._localeService) {
      return this._localeService.formatDate(value, format, timezone);
    }

    // Fallback if LocaleService isn't available
    try {
      const datePipe = new DatePipe('en-US');
      return datePipe.transform(value, format, timezone) || '';
    } catch (error) {
      return '';
    }
  }
}
